<script setup lang="ts">
  import type { NuxtError } from '#app'

  const props = defineProps<{
    error: NuxtError
  }>()

  const errorImage = computed(() => {
    switch (props.error?.statusCode) {
      case 404:
        return '/errors/404.svg'
      case 500:
        return '/errors/500.svg'
      default:
        return ''
    }
  })

  const { isMobile } = useBTBreakpoints()
  const { locale } = useI18n()

  const errorImageDimensions = computed(() => {
    return isMobile.value ? { width: 328, height: 127 } : { width: 558, height: 217 }
  })

  const { t } = useI18n()

  const errorMessage = computed(() => {
    if (props.error?.statusCode === 404) {
      return t(props.error.statusMessage ?? '')
    }

    if (props.error.statusCode === 500) {
      return isDev() ? props.error.message : t('global.error.serverError')
    }

    return ''
  })
</script>

<template>
  <NuxtLayout>
    <div class="container">
      <div class="flex w-full flex-col items-center gap-8 py-24 md:gap-12">
        <NuxtImg
          v-if="errorImage"
          :src="errorImage"
          :height="errorImageDimensions.height"
          :width="errorImageDimensions.width"
          :alt="$t(error?.statusMessage ?? '')"
        />
        <p
          v-if="errorMessage"
          class="text-bt-blue-dark text-lead"
        >
          {{ errorMessage }}
        </p>
        <div
          v-if="isDev() && error?.stack"
          class="text-gray-700 text-subtitle-2"
          v-html="error.stack"
        />

        <div class="max-w-sm">
          <NuxtLink
            class="flex size-10 items-center justify-center gap-2 rounded text-sm font-bold no-underline md:w-full md:bg-bt-green md:px-4 md:hover:bg-bt-green-hover"
            :to="`/${locale}/index`"
            external
          >
            {{ $t('backToHome') }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>
